import { clientAppFetch } from "./clientAppFetch";
import {
  SUIVI_REVIEW_CONTRACT_VERSION,
  SuiviReviewContractError,
  suiviEventKey,
} from "./fetchFeedbacksStream";

const EVENT_TYPES = new Set(["feedback", "client_message", "meal_photo"]);
const REF_KEYS = ["type", "id", "source_version"];

export function validateSuiviEventRefs(events) {
  if (!Array.isArray(events) || events.length === 0) {
    throw new SuiviReviewContractError("Au moins un événement Suivi est requis");
  }
  const seen = new Set();
  return events.map((event, index) => {
    if (!event || typeof event !== "object" || Array.isArray(event)) {
      throw new SuiviReviewContractError(`Référence events[${index}] invalide`);
    }
    const keys = Object.keys(event).sort();
    if (keys.length !== REF_KEYS.length || !REF_KEYS.every((key) => keys.includes(key))) {
      throw new SuiviReviewContractError(`Référence events[${index}] non conforme`);
    }
    if (!EVENT_TYPES.has(event.type)) {
      throw new SuiviReviewContractError(`Type events[${index}] invalide`);
    }
    if ((typeof event.id !== "string" && typeof event.id !== "number") || !String(event.id).trim()) {
      throw new SuiviReviewContractError(`Id events[${index}] invalide`);
    }
    if (typeof event.source_version !== "string" || !event.source_version.trim() || !Number.isFinite(Date.parse(event.source_version))) {
      throw new SuiviReviewContractError(`source_version events[${index}] invalide`);
    }
    const ref = { type: event.type, id: event.id, source_version: event.source_version };
    const key = suiviEventKey(ref);
    if (seen.has(key)) throw new SuiviReviewContractError(`Référence events[${index}] dupliquée`);
    seen.add(key);
    return ref;
  });
}

export async function markSuiviEventsTreated(events, { fetchApi = clientAppFetch } = {}) {
  const validEvents = validateSuiviEventRefs(events);
  const body = await fetchApi("/api/admin/suivi-events/mark-treated", {
    method: "POST",
    payload: { events: validEvents },
  });
  if (body?.review_contract_version !== SUIVI_REVIEW_CONTRACT_VERSION) {
    throw new SuiviReviewContractError("Contrat de traitement Suivi absent ou incompatible");
  }
  if (body?.ok !== true) {
    throw new SuiviReviewContractError("Le traitement des événements Suivi n'a pas été confirmé");
  }
  return body;
}
